export default __webpack_public_path__ + "static/media/x-ray-goggles.bedcaa10.svg";